<template>
  <div class="toolbar">
    <div class="col-1 float-right">
      <i class="fa-regular fa-bars"></i>
    </div>
    <div class="col-10 float-right">
      <h2 v-if="titlepage!=''" v-text="titlepage"></h2>
    </div>
    <div class="col-1 float-right">
      <i v-if="back!=''" class="fa-solid fa-chevron-left" @click="backHome()"></i>
    </div>
  </div>
</template>

<script >

export default {
  name: 'header-app',
  methods: {
    backHome(){
      return history.back();
    }
  },
  props: [
    "titlepage",
     "back"
  ],
}
</script>



<style scoped>
  .toolbar{
    width: 100%;
    height: 60px;
    background: #004815;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1000000;
    direction: rtl;
    padding: 10px;
    color: #fff;
  }
  .toolbar i{
    font-size: 24pt;
  }
  .toolbar .col-9{
    padding-right: 10px;
  }
</style>